import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06fe621f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"150px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "content")
], -1))
const _hoisted_2 = { class: "footer" }

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'dialog',
  setup(__props) {

const visible = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_u_dialog = _resolveComponent("u-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_button, {
      type: "primary",
      link: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode("Click to open Dialog")
      ]),
      _: 1
    }),
    _createVNode(_component_u_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      center: "",
      title: "title",
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})